import React from 'react';
import { ROUTES } from '@constants';
import spcgLogo from '@themes/images/spcg.svg';
import { Style } from './style';
import { useLocation } from 'react-router-dom';

type TopBarProps = {
  backgroundColor?: string;
  border?: string;
  borderBottom?: string;
};

const TopBar = ({ backgroundColor, border, borderBottom }: TopBarProps) => {
  let location = useLocation();
  const isAnimation = location.pathname ===  ROUTES.PLANT_LIST

  return (
    <Style $isAnimation={isAnimation} $backgroundColor={backgroundColor} $border={border} $borderBottom={borderBottom}>
      <div className='name'>
        <img className='logo' src={spcgLogo} alt={spcgLogo} />
      </div>
    </Style>
  );
};

export default TopBar